import i18n from 'commons/libs/i18n'
import { downloadFile, FileType } from 'commons/utils/file'
import { toast } from 'react-toastify'
import { downloadRecommendationsReport } from 'services/home'

import type { ScreenPerm } from '../Header/constants'
import type { MenuItem } from './MenuSidebar'

export const hasPermission = (
  items: MenuItem[],
  verifyFn: (screen: ScreenPerm | ScreenPerm[]) => boolean,
): boolean => {
  return items.some((item) => {
    const itemHasPermission = item.permission ? verifyFn(item.permission) : false

    const childrenHavePermission = item.menuItems ? hasPermission(item.menuItems, verifyFn) : false

    return itemHasPermission || childrenHavePermission
  })
}

export const allLinks = (items: MenuItem[]): string[] => {
  return items.reduce<string[]>((acc, item) => {
    if (item.to) acc.push(item.to)

    if (item.menuItems) {
      acc.push(...allLinks(item.menuItems))
    }

    return acc
  }, [])
}

export const handleRecommendationReportDownload = async () => {
  toast.info(i18n.t('common.messages.downloadStarting'))

  try {
    const file = await downloadRecommendationsReport()
    //NOTE: Ex: Recomendacao_Pedidos_YYYYMMDD_HHMM.xlsx
    const fileName = (() => {
      // NOTE: If necessary in the future, this format "YYYYMMDD_HHMM" can be added to DateFormats in the date.ts file
      // *if the format files name becomes the standard format
      const date = new Date(),
        value = (n: number) => String(n).padStart(2, '0')
      // TODO: Use i18n for file name
      return `Recomendacao_Pedidos_${date.getFullYear()}${value(
        date.getMonth() + 1,
      )}${value(date.getDate())}_${value(date.getHours())}${value(date.getMinutes())}.xlsx`
    })()

    downloadFile({
      file,
      fileName,
      fileType: FileType.Excel,
    })
    toast.success(i18n.t('common.messages.spreadsheetDownloadSuccess'))
  } catch (error) {
    toast.error(i18n.t('common.errors.unableToDownloadSpreadsheet'))
  }
}
